import type { ApiMagentoGetProductPriceResponse } from "@jti/magento-types";

export const getProductPriceApiResponseMock: ApiMagentoGetProductPriceResponse = {
  getProductPrice: {
    maximum_price: {
      final_price: {
        currency: "EUR",
        value: 321.98,
      },
      regular_price: {
        currency: "EUR",
        value: 321.98,
      },
    },
    minimum_price: {
      final_price: {
        currency: "EUR",
        value: 321.98,
      },
      regular_price: {
        currency: "EUR",
        value: 321.98,
      },
    },
  },
};
